"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _redux = require("redux");

var _reactRhumb = require("react-rhumb");

var _accessControl = _interopRequireDefault(require("settings-ui-app/containers/hoc/accessControl"));

var _AccessControl = require("settings-ui-modules/marketing/modules/form/constants/AccessControl");

var _UISection = _interopRequireDefault(require("UIComponents/section/UISection"));

var _loadOnMount = _interopRequireDefault(require("settings-ui-sdk/app/containers/hoc/loadOnMount"));

var _stageOnMount = _interopRequireDefault(require("settings-ui-sdk/app/containers/hoc/stageOnMount"));

var _UpdateFormSettings = _interopRequireDefault(require("settings-ui-modules/marketing/modules/form/stagedObjects/UpdateFormSettings"));

var _actions = require("settings-ui-sdk/FormSettings/actions");

var _constants = require("settings-ui-sdk/FormSettings/constants");

var _selectors = require("settings-ui-sdk/FormSettings/selectors");

var _EmaillessContacts = _interopRequireDefault(require("../components/EmaillessContacts"));

var FormSubmissionsSettingsContainer =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(FormSubmissionsSettingsContainer, _PureComponent);

  function FormSubmissionsSettingsContainer() {
    (0, _classCallCheck2.default)(this, FormSubmissionsSettingsContainer);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FormSubmissionsSettingsContainer).apply(this, arguments));
  }

  (0, _createClass2.default)(FormSubmissionsSettingsContainer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          emaillessContactsEnabled = _this$props.emaillessContactsEnabled,
          onEmailessContactsEnabledChanged = _this$props.onEmailessContactsEnabledChanged,
          readOnly = _this$props.readOnly;
      return _react.default.createElement(_UISection.default, null, _react.default.createElement(_EmaillessContacts.default, {
        enabled: emaillessContactsEnabled,
        onEnabledChanged: onEmailessContactsEnabledChanged,
        readOnly: readOnly
      }));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        emaillessContactsEnabled: _react.PropTypes.bool.isRequired,
        onEmailessContactsEnabledChanged: _react.PropTypes.func.isRequired,
        readOnly: _react.PropTypes.bool.isRequired
      };
    }
  }]);
  return FormSubmissionsSettingsContainer;
}(_react.PureComponent);

var mapStateToProps = function mapStateToProps(state) {
  return {
    emaillessContactsEnabled: _UpdateFormSettings.default.getStagedProperty(_constants.FORM_CREATE_EMAILLESS_CONTACT_ENABLED)(state)
  };
};

var actionsToBind = {
  onEmailessContactsEnabledChanged: _UpdateFormSettings.default.changeProperty(_constants.FORM_CREATE_EMAILLESS_CONTACT_ENABLED)
};

var _default = (0, _redux.compose)((0, _accessControl.default)({
  read: {
    and: [_AccessControl.FORMS_READ]
  },
  write: _AccessControl.FORMS_WRITE
}), (0, _loadOnMount.default)(_actions.loadFormSettings, _selectors.getFetchFormSettingsRequestStatus, null, true, _react.default.createElement(_reactRhumb.NavMarker, {
  name: "FORM_SUBMISSIONS_SETTINGS_LOADED"
}), _react.default.createElement(_reactRhumb.NavMarker, {
  name: "FORM_SUBMISSIONS_SETTINGS_LOADED_FAILURE"
})), (0, _stageOnMount.default)(_UpdateFormSettings.default.getDomainObject, _UpdateFormSettings.default.stageForEdit), (0, _reactRedux.connect)(mapStateToProps, actionsToBind))(FormSubmissionsSettingsContainer);

exports.default = _default;
module.exports = exports.default;